const locale = {
	PERSOMAT: "Persomat",
	OVERVIEW: "Overview",
	WELCOMEBACK: "Welcome back",
};

export default locale;
